module.exports = __webpack_public_path__ + "img/zain_logo.7d10b159.svg";